export enum Scope {
  ALL = 'all',
  SINGLE_TICKET = 'single-ticket',
  SINGLE_SURVEY = 'single-survey',
}
